import { isBrowser } from './browserHelper';
import { getNativeAccessToken } from './cookieHelper';
import { isNativeApp } from './nativeAppHelper';

export const authenticateUser = async (): Promise<IsLoggedInPayload> => {
  if (!isBrowser()) {
    return { isLoggedIn: false };
  }

  if (isNativeApp()) {
    const nativeAccessToken = getNativeAccessToken();
    if (!nativeAccessToken) throw new Error('Token not found');

    return { isLoggedIn: true, authToken: nativeAccessToken };
  }

  const isLoggedIn = window?.ikea?.authentication?.isLoggedIn;
  if (!isLoggedIn) {
    return { isLoggedIn: false };
  }

  try {
    const payload = await isLoggedIn();
    return payload;
  } catch {
    return { isLoggedIn: false };
  }
};
